module.exports = __webpack_public_path__ + "static/img/cont_01.7a504e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/relay-event/cont_01.jpg
// module id = Vt6F
// module chunks = 0